import request from './index'

export const consultationList = listQuery => {
    return request({
      url: '/user/consultation/list',
      method: 'post',
      data: {
        command_id: 0,
        entityId: listQuery.entityId,
        pageIndex: listQuery.pageIndex,
        pageSize: listQuery.pageSize,
        params: listQuery.params,
        fuzzySearch: listQuery.fuzzySearch
      }
    })
  }